import imageCompression from "browser-image-compression";

export const compressImage = async (input: string | File, maxSizeMB: number): Promise<{ uri: string; blob: Blob }> => {
  const file = input as File;

  const compressed = await imageCompression(file, {
    maxSizeMB,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
  });

  const blob = compressed as Blob;
  const uri = URL.createObjectURL(blob);
  const finalSizeMB = blob.size / (1024 * 1024);

  if (finalSizeMB > maxSizeMB) {
    alert(`Warning: Compressed image is still larger than ${maxSizeMB} MB (${finalSizeMB.toFixed(2)} MB)`);
  }

  return { uri, blob };
};
